module.exports = __webpack_public_path__ + "img/p5-p2-diaoxiang.89edee87.png";